module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectBigBlack.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectBigBlack.svg
// module id = 233
// module chunks = 0